import { useTranslation } from 'react-i18next';
import { onClickOpenReferenceMaterial } from 'core/utils/referenceMaterial';
import { hasRenderableHtml } from 'core/utils/utils';
import type { AttachmentContent } from 'app/types/attachment';

type UseMaterialPreviewStudentSidebarProps = {
  description?: string;
  referenceMaterial?: AttachmentContent | null;
  attachedFiles?: { name: string; size: number; type: string; url: string }[];
};

type UseMaterialPreviewStudentSidebarReturn = {
  t: (key: string, options?: Record<string, unknown>) => string;
  hasAttachments: boolean;
  handleShowVisor: () => void;
  description?: string;
  shouldShowDescription: boolean;
};

function useMaterialPreviewStudentSidebar({
  description,
  referenceMaterial,
  attachedFiles = [],
}: UseMaterialPreviewStudentSidebarProps): UseMaterialPreviewStudentSidebarReturn {
  const { t } = useTranslation(['actions', 'common']);

  const hasAttachments = !!(referenceMaterial || attachedFiles.length > 0);
  const shouldShowDescription = hasRenderableHtml(description);

  function handleShowVisor() {
    if (referenceMaterial) onClickOpenReferenceMaterial(referenceMaterial);
  }

  return { t, hasAttachments, handleShowVisor, description, shouldShowDescription };
}

export default useMaterialPreviewStudentSidebar;
